
























































import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import ScriptFilter from '@/domain/scripts/entity/rule-script-filter.entity';
import MainButton from '@/shared/buttons/main-button.component.vue';
import BusinessUnitService from '@/domain/business-unit/service/business-unit.service';
import Response from '@/domain/response.entity';
import EnumObject from '@/domain/enum-object.entity';
import Pagination from '@/domain/pagination.entity';
import RuleStatus from './rule-status.json';

@Component({ components: { MainButton } })
export default class ScriptsFilterComponent extends Vue {
  @Prop({
    required: true,
    default: '',
  })
  private businessUnitId!: string;

  locale = 'pt-BR';

  ref: any = this.$refs;

  filter = ScriptFilter.of({});

  statusList = RuleStatus;

  pagination: Pagination = new Pagination({
    page: 0,
    itemsPerPage: 100,
    defaultSort: 'name|asc',
  })

  clear() {
    this.ref.form.reset();
    this.filter = new ScriptFilter({});
  }

  send() {
    this.$emit('filter', this.filter);
  }

  checkAndApplyUrlFilter(): void {
    if (this.$route.params.status) {
      this.filter.status = this.$route.params.status;
    }
  }

  created() {
    this.checkAndApplyUrlFilter();
  }
}
